import { Component, computed, inject, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from '../../../../core/services/cookie/cookie.service';
import { Cookies } from '../../../../shared/enums/app.enums';
import { CustomSelectbox } from '../../../../shared/components/custom-selectbox/custom-selectbox';
import { SelectItem } from '../../../../shared/models/models';
import { ToasterService } from '../../../../shared/services/toaster.service';

type ReportType = { value: string; label: string };

@Component({
  selector: 'app-report-job-modal',
  standalone: true,
  imports: [ReactiveFormsModule, CustomSelectbox],
  templateUrl: './report-job-modal.html',
  styleUrl: './report-job-modal.scss'
})
export class ReportJobModal {
  private readonly cookieService = inject(CookieService);
  private readonly toasterService = inject(ToasterService);
  readonly reportForm = input.required<FormGroup>();
  readonly reportTypes = input.required<readonly ReportType[]>();
  readonly reportTypeControl = computed(
    () => this.reportForm().get('ReportType') as FormControl<string>
  );
  readonly reportSelectItems = computed<SelectItem[]>(() =>
    this.reportTypes().map(report => ({
      label: report.label,
      en: report.label,
      value: report.value,
    }))
  );
  readonly formValue = this.cookieService.getCookie(Cookies.MyBDJOBSUSERID)?.trim() ?? '';

  readonly closed = output<void>();
  readonly submitted = output<void>();

  submitReport(): void {
    this.submitted.emit();
    this.toasterService.open('Your report for this job has been received.', 'success');
  }
}